class InstantSearch {
    constructor(holderNode, filters) {
        this.holderNode = holderNode;
        this.filters = filters;
        this.text;
        this.results = [];
        this.companyUrlsVisited = [];
    }

    startSearch(form) {
        this.filters.hideFilterControls();
        this.text = form.elements.text.value;
        window.scrollTo({top: 0, behavior: 'smooth'}); // Scroll to top of page automatically
        const method = "POST";
        const input = new FormData(form);
        input.append("filters", JSON.stringify(this.filters.getFiltersForSearch()));
        const url = "../api/instant_search/instant_search_actions.php?action=search";
        const options = {responseType: "json"};
        const success = (response) => this.processSearchResponse(response);
        const error = () => {};
        coreFunctions.xhrHelper(method, url, success, error, input, options, form);
        return this;
    }

    processSearchResponse(response) {
        coreFunctions.checkForDebugMessages(response);
        this.results = response.results.map(element => new InstantSearchCompany(element, this));
        if (!coreFunctions.arrayIsEmpty(this.results)) {
            this.addSearchResultsToPage().formatResultsToExploreLink();
        } else {
            this.noSearchResultsAvailable();
        }
        return this;
    }

    noSearchResultsAvailable() {
        this.holderNode.appendChild(coreFunctions.createElementHelper("div", {innerHTML: "No companies matched your search.", class: "orange"}));
        return this;
    }

    formatResultsToExploreLink() {
        // Set filters object and store reference code
        const storedFiltersCode = coreFunctions.getRandomString(15);
        const filtersObject = {
            filters: {
                CompanyNumbers: this.results.map(element => element.companyNumber)
            },
            code: storedFiltersCode
        };
        localStorage.setItem("filters", JSON.stringify(filtersObject));

        // Set link to explore page
        const url = new URL(document.getElementById("resultsToExplorePageLink").href);
        url.searchParams.set("filters_code", storedFiltersCode);
        document.getElementById("resultsToExplorePageLink").href = url.href;

        return this;
    }
    
    addSearchResultsToPage() {
        coreFunctions.clearElementChildren(this.holderNode);
        const fragment = document.createDocumentFragment();
        const count = this.results.length;
        
        this.results.forEach((company, index) => fragment.appendChild(company.createCompanyDetailsCompactView(index, count)));
        this.holderNode.appendChild(fragment);

        return this;
    }
}